//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
export default {
  name: 'image-fileTypes-editor',
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      uploadPictureTypes: [{
        value: 'jpg',
        label: 'jpg'
      }, {
        value: 'jpeg',
        label: 'jpeg'
      }, {
        value: 'png',
        label: 'png'
      }, {
        value: 'gif',
        label: 'gif'
      }]
    };
  }
};